import {Injectable} from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class CustomStorageManager {

	private storage: { [key: string]: any } = {};

	constructor() {
	}

	getItem(key: string): any {
		return this.storage[key] || null;
	}

	setItem(key: string, value: any) {
		this.storage[key] = value;
	}

	removeItem(key: string) {
		delete this.storage[key];
	}

	clear() {
		this.storage = {};
	}
}
